var map = {
	"./da.json": 13903,
	"./en.json": 36617,
	"./es.json": 85429,
	"./id.json": 85552,
	"./it.json": 19462,
	"./ko.json": 57421,
	"./ms.json": 47723,
	"./ro.json": 90135,
	"./sv.json": 87148,
	"./th.json": 72924,
	"./vi.json": 98632,
	"./zh-cn.json": 69713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51133;